/* Express Matting collection pages: instant filtering (Section Rendering API), sort, load more,
   grid/list view, product compare, mobile filter drawer. Works without JS via normal links/forms. */
(() => {
  function boot() {
    const E = window.EMH; if (!E || E.col) return; E.col = true;
    const { $, $$, esc, ic, store, money, shown, vatLabel, toast } = E;
    const root = $("[data-emx-col]"); if (!root) return;
    root.classList.add("emx-js-ready");
    const sectionId = root.dataset.sectionId;
    let busy = false, ctl;

    /* ---------- Fetch a URL's version of this section and swap the results ---------- */
    async function load(url, { push = true, append = false } = {}) {
      if (busy && append) return;
      busy = true; ctl?.abort(); ctl = new AbortController();
      root.classList.add("is-loading");
      try {
        const u = new URL(url, location.origin);
        u.searchParams.set("section_id", sectionId);
        const html = await (await fetch(u, { signal: ctl.signal })).text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const next = doc.querySelector("[data-emx-col]");
        if (!next) throw new Error("No section");
        if (append) {
          const grid = $("[data-emx-grid]", root);
          $$("[data-emx-grid] > *", next).forEach(el => grid.appendChild(el));
          $("[data-emx-more]", root)?.replaceWith($("[data-emx-more]", next) || document.createComment("end"));
          $("[data-emx-count]", root).innerHTML = $("[data-emx-count]", next).innerHTML;
        } else {
          ["[data-emx-results]", "[data-emx-facets]", "[data-emx-active]"].forEach(sel => {
            const a = $(sel, root), b = $(sel, next); if (a && b) a.replaceWith(b);
          });
        }
        u.searchParams.delete("section_id");
        if (push && !append) history.pushState({ emx: 1 }, "", u.pathname + u.search);
        bindResults(); E.paintPrices(root); syncCompare();
        document.dispatchEvent(new CustomEvent("emh:mega", { detail: root }));
        if (!append) {
          const top = $("[data-emx-results]", root).getBoundingClientRect().top + scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 120) - 16;
          if (scrollY > top) scrollTo({ top, behavior: "smooth" });
          const n = $("[data-emx-count]", root)?.textContent.trim();
          if (n) $("[data-emx-live]", root).textContent = n;
        }
      } catch (e) { if (e.name !== "AbortError") location.href = url; }
      finally { busy = false; root.classList.remove("is-loading"); }
    }
    const formUrl = form => {
      const p = new URLSearchParams(new FormData(form));
      [...p.keys()].forEach(k => { if (p.get(k) === "") p.delete(k); });
      const sort = $("[data-emx-sort]", root)?.value; if (sort) p.set("sort_by", sort);
      return location.pathname + (p.toString() ? "?" + p : "");
    };

    /* Filters: apply instantly on change (desktop) */
    let t;
    root.addEventListener("change", e => {
      const form = e.target.closest("[data-emx-filter-form]");
      if (form) { clearTimeout(t); t = setTimeout(() => load(formUrl(form)), e.target.type === "number" ? 500 : 0); return; }
      if (e.target.matches("[data-emx-sort]")) {
        const u = new URL(location.href); u.searchParams.set("sort_by", e.target.value); u.searchParams.delete("page");
        load(u.pathname + u.search); store.set("sort", e.target.value);
      }
    });
    root.addEventListener("submit", e => { const f = e.target.closest("[data-emx-filter-form]"); if (f) { e.preventDefault(); load(formUrl(f)); E.closeLayer($("#emx-filters")); } });
    root.addEventListener("click", e => {
      const a = e.target.closest("a[data-emx-ajax]");
      if (a && !(e.metaKey || e.ctrlKey)) { e.preventDefault(); load(a.href); return; }
      const more = e.target.closest("[data-emx-more] a, [data-emx-more] button");
      if (more) { e.preventDefault(); load(more.dataset.next || more.href, { append: true, push: false }); return; }
    });
    addEventListener("popstate", () => load(location.href, { push: false }));

    /* Facet groups: collapse/expand and "show more values" */
    root.addEventListener("click", e => {
      const s = e.target.closest("[data-emx-showmore]"); if (!s) return;
      const g = s.closest(".emx-facet"); g.classList.toggle("is-all"); s.textContent = g.classList.contains("is-all") ? "Show fewer" : s.dataset.label;
    });

    /* Mobile filter drawer */
    document.addEventListener("click", e => {
      if (e.target.closest("[data-emx-open-filters]")) { e.preventDefault(); E.openLayer($("#emx-filters")); }
    });

    /* ---------- Grid / list view ---------- */
    function setView(v) {
      const grid = $("[data-emx-grid]", root); if (!grid) return;
      grid.classList.toggle("is-list", v === "list");
      $$("[data-emx-view]", root).forEach(b => b.setAttribute("aria-pressed", b.dataset.emxView === v));
    }
    root.addEventListener("click", e => { const b = e.target.closest("[data-emx-view]"); if (b) { store.set("view", b.dataset.emxView); setView(b.dataset.emxView); } });

    /* ---------- Compare (up to 3) ---------- */
    const bar = $("#emx-compare-bar"), panel = $("#emx-compare");
    let cmp = store.get("cmp", []).filter(c => c && c.handle);
    function syncCompare() {
      $$("[data-emx-cmp]", root).forEach(b => { const h = b.closest("[data-emh-product]")?.dataset.handle; const on = cmp.some(c => c.handle === h); b.setAttribute("aria-pressed", on); b.querySelector("span") && (b.querySelector("span").textContent = on ? "Comparing" : "Compare"); });
      if (!bar) return;
      bar.hidden = !cmp.length;
      $("[data-emx-cmp-list]", bar).innerHTML = cmp.map(c => `<span class="emx-cmp-chip"><img src="${esc(c.img)}" alt="" width="36" height="36"><b>${esc(c.title)}</b><button type="button" data-emx-uncmp="${esc(c.handle)}" aria-label="Remove ${esc(c.title)}">${ic("close", "emh-ic emh-ic-sm")}</button></span>`).join("") + (cmp.length < 3 ? `<span class="emx-cmp-slot">Add ${3 - cmp.length} more</span>` : "");
      $("[data-emx-cmp-go]", bar).disabled = cmp.length < 2;
    }
    function renderCompare() {
      const rows = [
        ["Price", c => `${c.varies ? '<small class="emh-from">From</small> ' : ""}${money(shown(c.price))} <small class="emh-vat-l">${vatLabel()}</small>`],
        ["Specification", c => esc(c.spec || "–")],
        ["Rating", c => c.num ? `<span class="emx-gold">★★★★★</span> ${esc(c.avg)} (${esc(c.num)})` : "No reviews yet"],
        ["Options", c => c.opts > 1 ? `${c.opts} sizes and options` : "One size"],
        ["Key points", c => (c.hl || []).slice(0, 3).map(h => `<div>• ${esc(h)}</div>`).join("") || "–"]
      ];
      $("[data-emx-cmp-body]", panel).innerHTML = `<div class="emx-cmp-scroll"><table class="emx-cmp-table"><thead><tr><th></th>${cmp.map(c => `<th><a href="${esc(c.url)}"><img src="${esc(c.img)}" alt="" width="120" height="90"><b>${esc(c.title)}</b></a></th>`).join("")}</tr></thead>
        <tbody>${rows.map(([l, f]) => `<tr><th scope="row">${l}</th>${cmp.map(c => `<td>${f(c)}</td>`).join("")}</tr>`).join("")}
        <tr><th></th>${cmp.map(c => `<td><a class="emh-btn emh-btn-red emh-btn-sm" href="${esc(c.url)}">View product</a></td>`).join("")}</tr></tbody></table></div>`;
    }
    root.addEventListener("click", e => {
      const b = e.target.closest("[data-emx-cmp]"); if (!b) return;
      const c = b.closest("[data-emh-product]"), h = c.dataset.handle;
      if (cmp.some(x => x.handle === h)) cmp = cmp.filter(x => x.handle !== h);
      else {
        if (cmp.length >= 3) { toast("You can compare up to 3 products"); return; }
        let hl = []; try { hl = JSON.parse(c.dataset.highlights || "[]") || []; } catch { }
        cmp.push({ handle: h, title: c.dataset.title, url: c.dataset.url, img: c.dataset.img, price: +c.dataset.price, varies: c.dataset.varies === "true", spec: c.dataset.spec, avg: c.dataset.avg, num: +c.dataset.num || 0, opts: +c.dataset.opts || 1, hl });
      }
      store.set("cmp", cmp); syncCompare();
    });
    document.addEventListener("click", e => {
      const u = e.target.closest("[data-emx-uncmp]"); if (u) { cmp = cmp.filter(x => x.handle !== u.dataset.emxUncmp); store.set("cmp", cmp); syncCompare(); if (panel?.classList.contains("is-open")) { cmp.length ? renderCompare() : E.closeLayer(panel); } return; }
      if (e.target.closest("[data-emx-cmp-go]")) { renderCompare(); E.openLayer(panel); return; }
      if (e.target.closest("[data-emx-cmp-clear]")) { cmp = []; store.set("cmp", cmp); syncCompare(); }
    });
    document.addEventListener("emh:vat", () => { if (panel?.classList.contains("is-open")) renderCompare(); });

    function bindResults() { setView(store.get("view", "grid")); }
    bindResults(); syncCompare();
  }
  if (window.EMH) boot(); else document.addEventListener("emh:ready", boot, { once: true });
})();
